(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/usystem-button.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/usystem-button.js'); 
(function(Backbone, _, svs) {
  svs.tipset.views.USystemButton = Backbone.Marionette.View.extend({
    modelEvents: {
      change: 'render',
      destroy: 'destroy'
    },
    log: new svs.core.log.Logger('svs.tipset.views.USystemButton'),
    isU: false,
    uMode: false,

    template: function(data) {
      return svs.tipset.templates.usystembutton(data);
    },

    onDestroy: function() {
      this.remove();
    }
  });
})(Backbone, _, svs);

 })(window);